module.exports = __webpack_public_path__ + "img/MIOTA.40b044bf.svg";